<template>
  <div class="col-10 m-0 p-0">
    <div class="col-12 row m-0 mt-5 mb-4 cust_card_time_div cust_card_time">
      <!-- 左邊div -->
      <div class="div_center m-0 d-flex flex-column flex-md-row align-items-center ">
        <div class="d-block d-md-inline-block div_center">
          <img class="cust_card_icon" :src="require('@/assets/icon/Ordering_statistics.png')" />
          <label class="m-0 ml-3 cust_card_time_label">訂餐時間：</label>
        </div>
      </div>
      <div class="div_center" style="flex: 1 1 auto;">

        <div style="flex: 0 0 auto;">
          <b-button class="p-0 m-0 date_change_week_button" @click="changeWeek(SupldtStart, -7)"
            :disabled="change_left">
            <b-icon icon="caret-left-fill" style="cursor: pointer;" scale="1.5"></b-icon>
          </b-button>
        </div>
        <label class="m-0 d-block d-md-inline-block cust_card_time_label"
          style="flex: 1 1 auto; max-width: 28.125rem;">{{
            SupldtShow
          }}</label>
        <div style="flex: 0 0 auto;">
          <b-button class="p-0 m-0 date_change_week_button" @click="changeWeek(SupldtStart, 7)"
            :disabled="change_right">
            <b-icon icon="caret-right-fill" style="cursor: pointer;" scale="1.5"></b-icon>
          </b-button>
        </div>

      </div>
      <!-- 右邊div -->
      <!-- <div class="div_center mr-3">
        <img class="cust_card_icon2" :src="require('@/assets/icon/編輯.png')" />
        <label class="m-0 ml-2" style="
            font-size: 1.25rem;
            color: #E27814;
            font-weight: 600;
            cursor: pointer;
          ">編輯</label>
      </div> -->
    </div>

    <div class="col-12 row m-0 p-0 justify-content-center my-2">
      <div class="col-12 p-0 row m-0">
        <div v-for="(item, index) in MenuList" :key="index"
          class="m-0 px-2 justify-content-center d-flex flex-column align-items-center flex-fill" :class="{
            cust_card_disable: !item.selected,
            cust_card: item.selected, 'mx-md-1': index != 0 && index != MenuList.length - 1, 'mr-md-1': index == 0 && MenuList.length > 1, 'ml-md-1': index == MenuList.length - 1 && MenuList.length > 1
          }" :style="{ width: 'calc(100% / ' + MenuList.length + ' + -10px)' }" @click="showMenu(item)">
          <div class="div_center ">
            <img class="cust_card_icon" :src="require('@/assets/icon/訂位.png')" />
            <label class="m-0 " style="font-size: 2rem; color: #E27814; cursor: pointer">{{ item.SuplNM }}</label>
          </div>
        </div>
      </div>
      <div class="col-12 p-0 mt-4">
        <img v-if="Menu != ''" style="width: 100%" :src="$Img.url + Menu" />
      </div>
      <div class="col-12 p-0 row m-0 mt-3 justify-content-between">
        <div v-for="(item, index) in DateList" :key="index" class="row m-0 date_modal_button p-0 div_center" :style="{
          'background-color': item.isfocus ? '#E58A37' : item.Is_selected ? '#FFF3E2' : 'white',
          color: item.isfocus ? 'white' : '#e58a37'
          , 'pointer-events': item.Is_disabled ? 'none' : '', 'filter': item.Is_disabled ? 'grayscale(100%)' : ''
        }" @click="selectDate(item)" style="position: relative;">
          <div v-if="item.Is_selected" style="position: absolute;background-color: white;top:-10px;right: 0;">
            <b-icon icon="check-circle-fill" style="color:#E27814" scale="2.5"></b-icon>
          </div>
          <label class="m-0 col-12 p-0 text-center" style="font-size: 2rem; cursor: pointer">{{
            item.Weekday
          }}</label>

        </div>
      </div>
      <div class="col-12 p-0 my-3" style="border-bottom: 2px solid #d9b89b"></div>
      <!--餐期-->
      <div class="col-12 p-0 mb-5" v-for="(item, index) in MealList" :key="index">
        <div class="d-flex justify-content-start col-12 p-0">
          <label class="m-0" style="font-size: 1.75rem; font-weight: 900; color: #a37e5c">
            {{ item.Model }}</label>
          <!--{{ item.Model == "早餐" ? " 07:00-09:00" : item.Model == "午餐" ? " 11:30-13:30" : item.Model ==
              "晚餐" ? " 17:30-19:30" : "" }}-->
          <!-- <div class="ml-2"
            :class="{ 'cust_card_meal_delivery': !item.delivery, 'cust_card_meal_delivery_selected': item.delivery }"
            style="cursor: pointer;position: relative;" @click="deliveryClick(item)">
            <div v-if="item.delivery" style="position: absolute;top:-10px;right: -10px;background-color: white;">
              <b-icon icon="check-circle-fill" style="color:#E27814" scale="1.5"></b-icon>
            </div>
            <label class="m-0 px-3" style="font-size: 1.75rem; font-weight: 600; color: #E27814;cursor: pointer;">
              送餐服務</label>
          </div> -->
        </div>
        <!--餐廳名稱-->
        <div v-for="(item4, index4) in item.SuplList" :key="index4">
          <div class="d-flex justify-content-start col-12 p-0">
            <label class="m-0" style="font-size: 1.75rem;  color: #E27814">
              {{ item4.Suplnm }}</label>
          </div>
          <div class="row m-0 p-0 d-flex flex-wrap" style="gap: 1rem;">
            <!--餐點卡片-->
            <div v-for="(item2, index2) in item4.MealList" class="px-3 d-flex flex-column card-flex"
              :class="{ 'cust_card_meal': !item2.Is_selected, 'cust_card_meal_selected': item2.Is_selected }"
              :key="index2" @click="show_order_modal(item2)">
              <div v-if="item2.Is_selected" style="position: absolute;top:-10px;right: 0;background-color: white;">
                <b-icon icon="check-circle-fill" style="color:#E27814" scale="2.5"></b-icon>
              </div>
              <!-- <div class="col-12 p-0 row m-0 justify-content-start mt-3" style="height:2.5rem;">style="height: 2.5rem;" -->
              <div class="p-0 d-flex justify-content-start mt-3">
                <label class="m-0" style="font-size: 2.5rem; color: #E27814; cursor: pointer;line-height: 100%;">{{
                  selectedDateShow }}</label>
              </div>
              <!-- <div class="row m-0 flex-grow-1" style="height: calc(100% + -3.5rem);"> -->
              <div class="row m-0" style="flex: 1 1 auto; min-height: 0;">
                <div class="col-12 col-lg-6 p-0 d-flex flex-column" style="">
                  <div class="p-0 row m-0 justify-content-start">
                    <label class="m-0 cust_card_meal2"
                      style="font-size: 2.5rem; color: #E27814; cursor: pointer;line-height: 100%;text-align: start;">{{
                        item2.Name }}</label>
                  </div>
                  <div class="p-0 row m-0 flex-grow-1 align-items-start">
                    <div class="p-0 row m-0 align-items-center" v-for="(item3, index3) in item2.mItem" :key="index3"
                      style="width:100%">
                      <label class="m-0 cust_card_meal2"
                        style="font-size: 2rem; color: #E27814; cursor: pointer;line-height: 100%;text-align: start;">{{
                          item3.mItemnm }}</label>
                    </div>
                  </div>
                  <div class="p-0 row m-0 align-items-center">
                    <div class="d-flex align-items-center" style="background-color: #E27814; padding: 5px">
                      <b-icon icon=" plus" scale="2" style="color: white"> </b-icon>
                    </div>
                    <label class="m-0 ml-2"
                      style="font-size: 2rem; color: #E27814; cursor: pointer;text-align: start;">NT$ {{
                        item2.Selling
                      }}</label>
                  </div>
                </div>
                <div class="col-12 col-lg-6 p-0 div_center" style="min-height: 11.5rem;">
                  <img v-if="item2.ImgPath != ''" style="width: 10.5rem;height: 10.5rem;object-fit: cover;"
                    :src="$Img.url + item2.ImgPath">
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5 row m-0 mt-2 justify-content-center" v-if="item4.MealList.length % 2 == 1">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12"
      style="position: sticky;background-color: #E27814;cursor:pointer;  border-radius: 0.5rem;bottom: 0;"
      @click="show_cart_modal">
      <label class="m-0" style="font-size: 1.75rem;  color: white;cursor:pointer;">查看購物車</label>
    </div>
    <b-modal ref="date_modal" hide-footer hide-header centered no-fade no-close-on-backdrop no-close-on-esc>
      <div class="col-12 row m-0 justify-content-end">
        <b-icon icon="x-circle-fill" style="color: #E27814; cursor: pointer" @click="hide_date_modal"></b-icon>
      </div>
      <div class="col-12 row m-0 mb-2">
        <label class="m-0" style="font-size: 2rem; color: #E27814">訂餐時間</label>
      </div>
      <div class="col-12 row m-0 justify-content-around">

        <div class="d-flex align-items-center"><b-icon icon="chevron-double-left" class="main_color"
            style="cursor: pointer;" @click="get7Days(SupldtStart, -7)"></b-icon></div>
        <div>
          <label class="m-0" style="font-size: 2rem; color: #E27814;user-select: none;"> {{ SupldtStart }} </label>
          <label class="m-0 ml-1" style="font-size: 2rem; color: #E27814;user-select: none;"> 到 </label>
          <label class="m-0 ml-1" style="font-size: 2rem; color: #E27814;user-select: none;"> {{ SupldtEnd }}
          </label>
        </div>
        <div class="d-flex align-items-center"><b-icon icon="chevron-double-right" class="main_color"
            style="cursor: pointer;" @click="get7Days(SupldtStart, 7)"></b-icon></div>
        <!--<div class="col-3 mt-2" v-for="(item, index) in DateList" :key="index">
          <div class="row m-0 date_modal_button p-0 div_center" :style="{
            'background-color': item.isfocus ? '#E58A37' : 'white',
            color: item.isfocus ? 'white' : 'black'
          }" @click="selectDate(item)">
            <label class="m-0 col-12 p-0 text-center" style="font-size: 0.6rem; cursor: pointer">{{ item.Weekday
            }}</label>
            <label class="m-0 col-12 p-0 text-center" style="font-size: 0.6rem; cursor: pointer">{{ item.date_show
            }}</label>
             <label class="m-0 col-12 p-0 text-center" style="font-size: 0.6rem; cursor: pointer">{{ index == 0 ? '今日' :
              '' }}</label>
          </div>
        </div> -->
      </div>
      <div class="col-12 row m-0 div_center mt-4">
        <b-button style="border: 0; background-color: #e58a37; width: 80%" @click="final_date">確定日期</b-button>
      </div>
    </b-modal>
    <b-modal ref="order_modal" hide-footer hide-header centered no-fade no-close-on-backdrop no-close-on-esc>
      <div class="col-12 row m-0 justify-content-end">
        <b-icon icon="x-circle-fill" scale="1.5" style="color: #E27814; cursor: pointer"
          @click="hide_order_modal"></b-icon>
      </div>
      <div class="col-12 row m-0 mb-2">
        <label class="m-0" style="font-size: 2rem; color: #E27814">{{
          select_Meal.Name
        }}</label>
      </div>
      <div class="col-12 row m-0">
        <div class="col-12 p-0 row m-0" v-for="(item3, index3) in select_Meal.mItem" :key="index3">
          <label class="m-0" style="font-size: 1.5rem; color: #E27814">{{
            item3.mItemnm
          }}</label>
        </div>
        <div class="col-12 p-0 row m-0 my-3 align-items-center">
          <label class="m-0" style="font-size: 1.5rem; color: #E27814">NT$ {{ select_Meal.Selling }}</label>
        </div>
        <div class="col-12 p-0 row m-0 my-3 align-items-center">
          <label class="m-0" style="font-size: 1.5rem; color: #E27814">餐點備註</label>
          <b-textarea style="font-size: 1.5rem;" v-model="remark"> </b-textarea>
        </div>
      </div>
      <div class="col-12 p-0" style="border-bottom: 2px solid #c9c9c9"></div>
      <div class="col-12 row p-0 m-0 div_center mt-4">
        <div class="col-12 col-sm-6">
          <b-input-group class="d-flex justify-content-center" style="width: 100%">
            <b-input-group-prepend>
              <b-button class="align-items-center d-flex" @click="Qty_change('-')">
                <b-icon icon="dash"></b-icon>
              </b-button>
            </b-input-group-prepend>
            <b-input-group-text class="d-flex justify-content-center" style="width: 50%;font-size: 1.3rem;">
              {{ Qty }}
            </b-input-group-text>
            <b-input-group-append>
              <b-button class="align-items-center d-flex" @click="Qty_change('+')">
                <b-icon icon="plus"></b-icon>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-12 col-sm-6 p-0">
          <b-button style="border: 0; background-color: #e58a37; width: 100%;font-size: 1.3rem;" @click="add_to_cart"
            :disabled="Qty === 0">加入購物車 NT$ {{ select_Meal.Selling * Qty }}</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal ref="cart_modal" hide-footer hide-header centered no-fade no-close-on-backdrop no-close-on-esc>
      <div class="col-12 row m-0 justify-content-end">
        <b-icon icon="x-circle-fill" scale="1.5" style="color: #E27814; cursor: pointer"
          @click="hide_cart_modal"></b-icon>
      </div>
      <div class="col-12 row m-0 p-0 mb-2">
        <label class="m-0" style="font-size: 2rem">你的訂單</label>
      </div>
      <div class="col-12 row m-0 p-0 mb-2">
        <div class="col-12 row p-0 m-0 my-3 cust_card_time_div cust_card_time_modal">
          <!-- 左邊div  @click="show_date_modal" -->
          <div class="div_center d-flex flex-column flex-md-row align-items-center">
            <div class="d-block d-md-inline-block div_center">
              <img class="cust_card_icon_modal" :src="require('@/assets/icon/Ordering_statistics.png')" />
              <label class="m-0 ml-3 cust_card_time_label_modal">訂餐時間：</label>
            </div>
            <label class="m-0 d-block d-md-inline-block cust_card_time_label_modal">{{ SupldtShow }}</label>
          </div>

          <!-- 右邊div 
          <div class="div_center">
            <img class="cust_card_icon_modal" :src="require('@/assets/icon/Ordering_statistics.png')" />
            <label class="m-0 ml-2" style="
                font-size: 1rem;
                color: #E27814;
                font-weight: 600;
                cursor: pointer;
              ">編輯</label>
          </div>-->
        </div>
      </div>
      <div class="col-12 row m-0 p-0 mb-2" v-for="(item, index) in Order.Meals" :key="index"
        style="border-bottom: 1px solid #c9c9c9">
        <div class="col-12 row m-0 p-0 justify-content-between" style="font-size: 1.5rem;">
          {{ item.Supldt }} {{ item.Model }}
        </div>
        <div class="col-12 row m-0 p-0 justify-content-between">
          <div class="col-12 col-sm-6 row m-0 p-0">
            <label class="m-0" style="
                font-size: 1.5rem;
                font-weight: 600;
                align-items: center;
                display: flex;
              ">{{ item.Name }}</label>
            <label class="m-0 ml-2" style="
                font-size: 1.5rem;
                font-weight: 600;
                align-items: center;
                display: flex;
              ">NT$ {{ item.Selling }}</label>
          </div>
          <div class="col-12 col-sm-6 row m-0 p-0 justify-content-end">
            <div class="col-12 row m-0 p-0 justify-content-end">
              <div class="col-12 col-sm-6 p-0 align-items-center d-flex">
                <b-input-group class="d-flex justify-content-center" style="width: 100%;">
                  <b-input-group-prepend>
                    <b-button class="d-flex justify-content-center align-items-center"
                      @click="Qty_change_cart(item, '-')" style="width: 1.3rem; height: 1.5rem">
                      <b-icon icon="dash"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                  <b-input-group-text class="d-flex justify-content-center"
                    style="width: 50%; height: 1.5rem;font-size: 1.5rem;">
                    {{ item.Qty }}
                  </b-input-group-text>
                  <b-input-group-append>
                    <b-button class="d-flex justify-content-center align-items-center"
                      @click="Qty_change_cart(item, '+')" style="width: 1.3rem; height: 1.5rem">
                      <b-icon icon="plus"></b-icon>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <div style="min-width: 70px;font-size: 1.2rem;">
                <div class="d-flex justify-content-end">
                  <label class="m-0">NT$ {{ item.Qty * item.Selling }}</label>
                </div>
                <div class="d-flex justify-content-end">
                  <label class="m-0" style="cursor: pointer; color: red"
                    @click="show_cart_delete_modal(item)">移除</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 row m-0 p-0">
          <div class="col-12 p-0 row m-0" v-for="(item2, index2) in item.rItem" :key="index2">
            <label class="m-0" style="font-size: 1.3rem; font-weight: 600">{{
              item2.rItemnm
            }}</label>
          </div>
          <div class="col-12 p-0 row m-0 align-items-center">
            <label class="m-0" style="
                font-size: 1.5rem;
                font-weight: 600;
                width: 100%;
                white-space: normal;
                word-break: break-all;
              ">備註:{{ item.Remark }}</label>
          </div>
        </div>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-between" style="font-size: 1.5rem;">
        <label>總付款金額</label>
        <label>NT${{ Order.AMOUNT }}</label>
      </div>
      <div class="col-12 row m-0 justify-content-around mt-4">
        <b-button style="border: 0; background-color: #e58a37; width: 45%" @click="hide_cart_modal">繼續點餐</b-button>
        <b-button style="border: 0; background-color: #e58a37; width: 45%"
          @click="show_check_date_modal">前往結帳</b-button>
      </div>
    </b-modal>
    <b-modal ref="cart_delete_modal" hide-footer hide-header centered no-fade no-close-on-backdrop no-close-on-esc>
      <div class="col-12 row m-0 justify-content-center mt-4">
        <label class="m-0" style="font-size: 1.75rem">是否移除此餐點?</label>
      </div>
      <div class="col-12 row m-0 justify-content-around mt-4">
        <b-button style="border: 0; background-color: #e58a37" @click="cart_delete_func">移除</b-button>
        <b-button style="border: 0; background-color: #e58a37" @click="hide_cart_delete_modal">取消</b-button>
      </div>
    </b-modal>
    <b-modal ref="check_date_modal" hide-footer hide-header centered no-fade no-close-on-backdrop no-close-on-esc>
      <div class="col-12 row m-0 justify-content-end">
        <b-icon icon="x-circle-fill" scale="1.5" style="color: #E27814; cursor: pointer"
          @click="hide_check_date_modal"></b-icon>
      </div>
      <div class="col-12 row m-0 p-0 mb-2">
        <label class="m-0 p-0 col-12 text-start" style="font-size: 2rem;font-weight: 500;">你的訂單</label>
      </div>
      <div class="col-12 row m-0 p-0 mb-2 align-items-center">
        <img style="width: 1.5rem; height: 1.5rem;filter: brightness(0) invert(0);"
          :src="require('@/assets/icon/Ordering_statistics.png')" />
        <label class="m-0 ml-2 text-center" style="font-size: 1.5rem;font-weight: 500;">訂餐時間：{{ SupldtShow }}</label>
      </div>
      <div class="col-12 row m-0 p-0 mb-2" v-for="(item, index) in Order.Meals" :key="index">
        <div class="col-12 row m-0 p-0" style="font-size: 2rem;font-weight: 500;">
          {{ item.Supldt }}
        </div>
        <div class="col-12 row m-0 p-0 justify-content-between">
          <div class="col-12 row m-0 p-0">
            <label class="m-0" style="
                font-size: 2rem;
                font-weight: 500;
                align-items: center;
                display: flex;
              ">{{ item.Name }}</label>
            <label class="m-0 ml-2" style="
                font-size: 1.5rem;
                font-weight: 500;
                align-items: center;
                display: flex;
              ">NT$ {{ item.Selling }}</label>
            <label class="m-0 ml-2" style="font-size: 1.5rem;font-weight: 500;
                align-items: center; display: flex;">{{ 'x ' + item.Qty }}</label>
            <label class="m-0 ml-auto"
              style="min-width: 70px;font-size: 1.25rem; align-items: center; display: flex;">NT$
              {{ item.Qty *
                item.Selling }}</label>
          </div>
          <!-- <div class="col-12 col-sm-4 row m-0 p-0 justify-content-end">
            <div class="col-12 row m-0 p-0 justify-content-end">
              <div class="d-flex align-items-center" style="min-width: 70px">
                <div class="d-flex justify-content-end">
                 
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="col-12 row m-0 p-0">
          <div class="col-12 p-0 row m-0" v-for="(item2, index2) in item.rItem" :key="index2">
            <label class="m-0" style="font-size: 1.25rem;font-weight: 500;">{{
              item2.rItemnm
            }}</label>
          </div>
          <div class="col-12 p-0 row m-0 align-items-center">
            <label class="m-0" style="
                font-size: 1.25rem;
                font-weight: 500;
                width: 100%;
                white-space: normal;
                word-break: break-all;
              ">備註:{{ item.Remark }}</label>
          </div>
        </div>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-between" style="border-top: 1px solid #c9c9c9;font-size: 1.5rem;">
        <label>總付款金額</label>
        <label>NT${{ Order.AMOUNT }}</label>
      </div>
      <div class="col-12 row m-0 justify-content-center mt-4">
        <div class="col-6 d-flex justify-content-center">
          <b-button style="border: 1px solid black; width: 100%;font-size: 1.5rem;" variant="light"
            @click="hide_check_date_modal('opencart')">繼續點餐</b-button>
        </div>
        <div class="col-6 d-flex justify-content-center">
          <b-button style="border: 0; background-color: #e58a37; width: 100%;font-size: 1.5rem;"
            @click="SaveOrder">確定結帳</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal ref="order_finished_modal" hide-footer hide-header centered no-fade no-close-on-backdrop no-close-on-esc>
      <div class="col-12 row m-0 justify-content-end mb-4">
        <b-icon icon="x-circle-fill" style="color: #E27814; cursor: pointer"
          @click="hide_order_finished_modal"></b-icon>
      </div>
      <!-- <div class="col-12 row m-0 p-0 mb-2 justify-content-center">
        <img :src="$Img.url + Supl.LOGO" :alt="Supl.SuplNM" class="cust_card_vLOGO" />
        <div class="col-12 d-flex justify-content-center">
          <label class="m-0" style="color: #9b7f7f; font-size: 1.75rem">{{
            Supl.SuplNM
          }}</label>
        </div>
      </div> -->
      <div class="col-12 row m-0 p-0 mb-2">
        <!-- 左邊div -->
        <div class="div_center d-flex flex-column flex-md-row align-items-start">
          <div class="d-block d-md-inline-block div_center">
            <img style="width: 1.5rem; height: 1.5rem" :src="require('@/assets/icon/Ordering_statistics.png')" />
            <!-- <label class="m-0 ml-2" style="font-size: 1rem; cursor: pointer">訂餐時間：</label> -->
          </div>
          <!-- <label class="m-0 d-block d-md-inline-block" style="font-size: 1rem; cursor: pointer">{{ 
            Order_finish.Supldt_show }}</label>-->
        </div>
      </div>
      <div class="col-12 row m-0 p-0 mb-2" v-for="(item, index) in Order_finish.Meals" :key="index">
        <div class="col-12 row m-0 p-0" style="font-size: 1.5rem;">
          {{ item.Supldt }}
        </div>
        <div class="col-12 row m-0 p-0 justify-content-between">
          <div class="col-12 col-sm-6 row m-0 p-0">
            <label class="m-0" style="
                font-size: 1.5rem;
                font-weight: 600;
                align-items: center;
                display: flex;
              ">{{ item.Name }}</label>
            <label class="m-0 ml-2" style="
                font-size: 1.5rem;
                font-weight: 600;
                align-items: center;
                display: flex;
              ">NT$ {{ item.Selling }}</label>
          </div>
          <div class="col-12 col-sm-6 row m-0 p-0 justify-content-end">
            <div class="col-12 row m-0 p-0 justify-content-end">
              <div class="col-12 col-sm-6 p-0 align-items-center d-flex">
                <!-- <b-input-group class="d-flex justify-content-center" style="width: 100%">
                  <b-input-group-prepend>
                    <b-button class="d-flex justify-content-center align-items-center" style="width: 1.3rem; height: 20px"
                      disabled>
                      <b-icon icon="dash"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                  <b-input-group-text class="d-flex justify-content-center" style="width: 50%; height: 20px">
                    {{ item.Qty }}
                  </b-input-group-text>
                  <b-input-group-append>
                    <b-button class="d-flex justify-content-center align-items-center" style="width: 20px; height: 20px"
                      disabled>
                      <b-icon icon="plus"></b-icon>
                    </b-button>
                  </b-input-group-append>
                </b-input-group> -->
                <label class="m-0" style="font-size: 1.5rem;">{{ 'x' + item.Qty }}</label>
              </div>
              <div style="min-width: 70px">
                <div class="d-flex justify-content-end">
                  <label class="m-0" style="font-size: 1.5rem;">NT$ {{ item.Qty * item.Selling }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 row m-0 p-0">
          <div class="col-12 p-0 row m-0" v-for="(item2, index2) in item.rItem" :key="index2">
            <label class="m-0" style="font-size: 1.5rem; font-weight: 600">{{
              item2.rItemnm
            }}</label>
          </div>
          <div class="col-12 p-0 row m-0 align-items-center">
            <label class="m-0" style="
                font-size: 1.5rem;
                font-weight: 600;
                width: 100%;
                white-space: normal;
                word-break: break-all;
              ">備註:{{ item.Remark }}</label>
          </div>
        </div>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-between" style="border-top: 1px solid #c9c9c9;font-size: 1.5rem;">
        <label>總付款金額</label>
        <label>NT${{ Order_finish.AMOUNT }}</label>
      </div>
      <div class="col-12 row m-0 justify-content-around mt-4">
        <b-button style="border: 0; background-color: #e58a37; width: 45%;font-size: 1.5rem;"
          @click="hide_order_finished_modal">確定資訊</b-button>
      </div>
    </b-modal>
    <b-modal ref="can_go_calendar_modal" hide-footer hide-header centered no-fade no-close-on-backdrop no-close-on-esc>
      <div class="col-12 row m-0 justify-content-end">
        <b-icon icon="x-circle-fill" scale="1.5" style="color: #E27814; cursor: pointer"
          @click="hide_check_date_modal('all_complete')"></b-icon>
      </div>
      <div class="col-12 row m-0 p-0 mb-2">
        <label class="m-0 col-12 text-center" style="font-size: 1.5rem;">您已完成訂單</label>
        <label class="m-0 col-12 text-center mt-3" style="font-size: 1.5rem;">可至個人行事曆查看</label>
      </div>
      <div class="col-12 row m-0 justify-content-center mt-4">
        <div class="col-12 d-flex justify-content-center">
          <b-button style="border: 0; background-color: #e58a37; width: 120px;font-size: 1.5rem;"
            @click="hide_can_go_calendar_modal">確定</b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>
<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      Order: {
        Supldt: '',
        Supldt_show: '',
        Createmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        Meals: [],
        AMOUNT: 0,
        SuplNO: '',
        ShopNO: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('ShopNO')
        ),
        UserName: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('UserName')
        ),
        Homeid: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Homeid')
        ),
        Userid: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        )
      },
      Supl: [],
      Meal_Supldt_List: [],
      MealList: [],
      DateList: [],
      SupldtStart: '',
      SupldtEnd: '',
      SupldtShow: '',
      selectedDate: '',
      selectedDateShow: '',
      select_type: '',
      Default_Meal: {
        Flowno: '',
        Homeid: '',
        Supldt: '',
        UserName: '',
        Mobile: '',
        Suplnm: '',
        SuplNO: '',
        ShopNO: '',
        Type: '',
        Model: '',
        Name: '',
        Qty: 0,
        Pricing: 0,
        Selling: 0,
        TotalSelling: 0,
        Remark: '',
        rItem: [],
        Createmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        Updmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        MealFlowno: '',
      },
      MenuList: '',
      Menu: '',
      notes:
        '安心在家享用美食<br />123123<br />456456<br />456456<br />456456<br />456456<br />456456',
      select_Meal: [],
      Qty: 1,
      remark: '',
      cart_delete: [],
      Order_finish: [],
      LocalList: [],
      change_left: false,
      change_right: false,
      IS_ON_FIRST_PAGE: false,
    };
  },
  watch: {},
  mounted() {
    this.init();
    window.addEventListener("message", this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      console.log("Received message event:", event);
      console.log("Message data:", event.data);

      if (event.data === "backButtonClick") {
        if (this.IS_ON_FIRST_PAGE) {
          parent.postMessage("goToHome", "*");
        } else {
          // Vue Router 返回上一頁
          this.$router.back();
        }
      }
    },
    async init() {
      this.change_left = true;
      await this.getDate_Modal();
    },
    GoAction(name) {
      this.$router.push({
        name: name
      });
    },
    //菜單
    GetMealMenu() {
      this.Menu = '';
      this.MenuList = [];
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(
          JSON.stringify({
            Menustart: this.SupldtStart.replaceAll('-', '/'),
            ShopNO: this.$Global.Base64Utils.atou(
              this.$cookieFunc.getCookie('ShopNO')
            )
          })
        )
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.GetMealMenu,
        data: post_data
      })
        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          this.MenuList = data;
          for (var i in this.MenuList) {
            this.MenuList[i]["selected"] = false
          }
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    },
    showMenu(item) {
      if (item.selected == true) {
        item.selected = false;
        this.Menu = '';
        return;
      }
      for (var i in this.MenuList) {
        if (this.MenuList[i] != item) {
          this.MenuList[i].selected = false
        }
      }
      item.selected = true
      this.Menu = item.Menudata;
    },
    //餐點
    async GetMeal() {
      this.MealList = [];
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(
          JSON.stringify({
            Suplstart: this.SupldtStart.replaceAll('-', '/'),
            Suplend: this.SupldtEnd.replaceAll('-', '/'),
            ShopNO: this.$Global.Base64Utils.atou(
              this.$cookieFunc.getCookie('ShopNO')
            )
          })
        )
      };

      await this.$axios({
        method: 'post',
        url: this.$URLJson.GetMeal,
        data: post_data
      })
        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          this.Meal_Supldt_List = data;
          //console.log(data);
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    },
    selectDate(item) {
      console.log(item)
      for (var i in this.DateList) {
        this.DateList[i].isfocus = false;
        this.DateList[i].Is_selected = false;
      }
      var idx = this.DateList.findIndex(function (o) {
        return o == item;
      });
      this.DateList[idx].isfocus = true;
      this.selectedDate = this.DateList[idx].date
      this.selectedDateShow = this.DateList[idx].date_show + '(' + this.DateList[idx].Weekday + ')';
      this.MealList = this.Meal_Supldt_List.find(x => x.Supldt == this.selectedDate.replaceAll('-', '/')).ModelList
      for (var i in this.MealList) {
        this.MealList[i]["delivery"] = false;
      }
      this.check_in_cart();
    },
    async final_date() {
      var n_date = await this.$Global.GetDate();
      //var n_date = '2025/06/08';
      let tempdt = new Date(this.SupldtStart)
      let tempdt2 = new Date(this.SupldtEnd)
      this.SupldtShow =
        tempdt.getFullYear() + '年' + (tempdt.getMonth() + 1) + '月' + tempdt.getDate() + '日' +
        ' ～ ' +
        (tempdt2.getMonth() + 1) + '月' + tempdt2.getDate() + '日'
      //var temp_item = this.DateList.filter((x) => x.isfocus == true);
      var templist = this.getNext7Days();
      this.DateList = [];
      for (var i in templist) {
        //console.log(Number(templist[i].substring(5, 7)).toString() + '月' + Number(templist[i].substring(8, 10)).toString() + '日')
        this.DateList.push({
          date_show:
            Number(templist[i].substring(0, 4)).toString() +
            '年' +
            Number(templist[i].substring(5, 7)).toString() +
            '月' +
            Number(templist[i].substring(8, 10)).toString() +
            '日',
          date: templist[i],
          Weekday: this.getWeekday(templist[i]).replace('星期', ''),
          isfocus: false,
          Is_selected: false,
          Is_disabled: (templist[i] <= n_date ? true : false)
        });
      }

      await this.GetMealMenu();
      await this.GetMeal();
      this.hide_date_modal();

    },

    show_date_modal() {
      if (this.Order.Meals.length > 0) {
        this.$parent.Msg('購物車已有餐點，無法換日期！', '5', 'warning');
        return;
      }
      this.$refs.date_modal.show();
    },
    hide_date_modal() {
      this.$refs.date_modal.hide();
    },
    //----取得訂餐時間選項----
    async getDate_Modal() {
      var n_date = await this.$Global.GetDate();
      var n_time = await this.$Global.GetTime();
      // var n_date = '2025/06/08';
      // var n_time = '18:00:01';
      let currentDate = new Date(n_date);
      if (currentDate.getDay() == 6 && n_time > '17:00:00')//如果是星期六，超過下午五點就不能訂星期日的 要跳到下一周
      {
        this.get7Days(n_date, 7)
      }
      else if (currentDate.getDay() == 0) {
        this.get7Days(n_date, 7)
      }
      else {
        this.get7Days(n_date, 0)
      }
      await this.final_date();
      var idx = this.DateList.findIndex(function (o) {
        return o.Is_disabled == false;
      });
      if (n_time > '17:00:00') {
        if (currentDate.getDay() != 6) {
          this.DateList[idx].Is_disabled = true;
          idx = idx + 1 == 7 ? 0 : idx + 1;
        }
      }
      if (idx > -1) {
        this.selectDate(this.DateList[idx]);
      }
    },
    get7Days(sdate, type) {
      let currentDate = new Date(sdate);
      if (currentDate.getDay() == 0) {
        this.SupldtStart = this.addDay(currentDate, -6 + type)
      }
      else {
        this.SupldtStart = this.addDay(currentDate, 1 - currentDate.getDay() + type)
      }
      this.SupldtEnd = this.addDay(new Date(this.SupldtStart), 6)

      // if (this.Order.Supldt == '') {
      //   this.Order.Supldt = this.DateList[0].date;
      //   this.Order.Supldt_show =
      //     this.DateList[0].date_show + ' ' + this.DateList[0].Weekday;
      //   this.DateList[0].isfocus = true;
      // }
    },
    addDay(date, addDays) {
      const res_date = new Date(date);
      res_date.setDate(res_date.getDate() + addDays);
      return this.$Global.DateFormat(res_date, '-')
    },
    getNext7Days() {
      const dateArray = [];
      let currentDate = new Date(this.SupldtStart);

      for (let i = 0; i < 7; i++) {
        let newDate = new Date(currentDate);
        dateArray.push(
          newDate.toLocaleDateString('zh-TW', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          })
        );
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dateArray;
    },
    getWeekday(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-TW', { weekday: 'long' });
    },
    async changeWeek(sdate, type) {
      if (this.Order.Meals.length > 0) {
        this.$parent.Msg('購物車已有餐點，無法換日期！', '5', 'warning');
        return;
      }
      if (type == 7) {
        this.change_left = false;
        this.change_right = true;
      }
      else {
        this.change_left = true;
        this.change_right = false;
      }
      this.get7Days(sdate, type)
      await this.final_date();
      var idx = this.DateList.findIndex(function (o) {
        return o.Is_disabled == false;
      });
      if (idx > -1) {
        this.selectDate(this.DateList[idx]);
      }
    },
    //----取得訂餐時間選項END----
    show_order_modal(item) {
      this.select_Meal = item;
      this.$refs.order_modal.show();
    },
    hide_order_modal() {
      this.select_Meal = [];
      this.Qty = 1;
      this.remark = '';
      this.$refs.order_modal.hide();
    },
    Qty_change(type) {
      if (type === '-') {
        if (this.Qty > 0) {
          this.Qty = this.Qty - 1;
        }
      }
      if (type === '+') {
        this.Qty = this.Qty + 1;
      }
    },
    add_to_cart() {
      this.select_Meal.orderQty = this.Qty;
      this.select_Meal.custRemark = this.remark;
      let tempObj = JSON.parse(JSON.stringify(this.Default_Meal));
      tempObj.Flowno = '';
      tempObj.Homeid = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('Homeid')
      );
      tempObj.Supldt = this.selectedDate.replaceAll('-', '/');
      tempObj.UserName = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('UserName')
      );
      tempObj.Mobile = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('Mobile')
      );
      tempObj.Suplnm = this.select_Meal.Suplnm;
      tempObj.SuplNO = this.select_Meal.SuplNO;
      tempObj.ShopNO = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('ShopNO')
      );
      tempObj.Type = this.select_Meal.Type;
      tempObj.Model = this.select_Meal.Model;
      tempObj.Name = this.select_Meal.Name;
      tempObj.Qty = this.Qty;
      tempObj.Pricing = this.select_Meal.Pricing;
      tempObj.Selling = this.select_Meal.Selling;
      tempObj.TotalSelling = this.Qty * this.select_Meal.Selling;
      tempObj.Remark = this.remark;
      for (var i in this.select_Meal.mItem) {
        tempObj.rItem.push({
          Flowno: this.select_Meal.mItem[i].Flowno,
          rItem: this.select_Meal.mItem[i].mItem,
          rItemnm: this.select_Meal.mItem[i].mItemnm,
          Seqno: this.select_Meal.mItem[i].Seqno
        });
      }
      tempObj.Createmem = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('Userid')
      );
      tempObj.Updmem = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('Userid')
      );
      tempObj.MealFlowno = this.select_Meal.Flowno
      //console.log(this.select_Meal)
      this.Order.Meals.push(JSON.parse(JSON.stringify(tempObj)));
      this.calc_AMOUNT();
      this.hide_order_modal();
      //this.show_cart_modal();
      this.check_in_cart();
    },
    calc_AMOUNT() {
      this.Order.AMOUNT = 0;
      for (var i in this.Order.Meals) {
        let temp_meal = this.Order.Meals[i];
        this.Order.AMOUNT += temp_meal.Selling * temp_meal.Qty;
      }
    },
    Qty_change_cart(item, type) {
      console.log(item)
      if (type === '-') {
        if (item.Qty > 1) {
          item.Qty = item.Qty - 1;
        } else {
          this.cart_delete = item;
          this.$refs.cart_delete_modal.show();
          return;
        }
      }
      if (type === '+') {
        item.Qty = item.Qty + 1;
      }
      this.calc_AMOUNT();
    },
    show_cart_modal() {
      this.Order.Meals = this.sortOrder(this.Order.Meals);
      //console.log(JSON.stringify(this.Order.Meals))
      this.$refs.cart_modal.show();
    },
    hide_cart_modal() {
      this.$refs.cart_modal.hide();
    },
    show_cart_delete_modal(item) {
      this.cart_delete = item;
      this.$refs.cart_delete_modal.show();
    },
    hide_cart_delete_modal() {
      this.$refs.cart_delete_modal.hide();
    },
    cart_delete_func() {
      var _this = this;

      if (this.cart_delete.Name == '送餐服務') {
        let tMealSupldt = this.Meal_Supldt_List.find(x => x.Supldt == this.cart_delete.Supldt)
        let tMealModel = tMealSupldt.ModelList.find(x => x.Model == this.cart_delete.Model)
        tMealModel.delivery = false;
      }
      else {
        let tMealSupldt = this.Meal_Supldt_List.find(x => x.Supldt == this.cart_delete.Supldt)
        let tMealModel = tMealSupldt.ModelList.find(x => x.Model == this.cart_delete.Model)
        let tMealSupl = tMealModel.SuplList.find(x => x.SuplNO == this.cart_delete.SuplNO)
        let tMeal = tMealSupl.MealList.find(x => x.Flowno == this.cart_delete.MealFlowno)
        tMeal["Is_selected"] = false;
      }
      let idx = this.Order.Meals.findIndex(function (o) {
        return o == _this.cart_delete;
      });

      this.Order.Meals.splice(idx, 1);


      this.calc_AMOUNT();
      this.hide_cart_delete_modal();
      this.check_in_cart();
    },
    show_check_date_modal() {
      if (this.Order.Meals.length == 0) {
        this.$parent.Msg('購物車沒有餐點！', '5', 'warning');
        return;
      }
      this.hide_cart_modal();
      this.$refs.check_date_modal.show();
    },
    hide_check_date_modal(type) {
      this.$refs.check_date_modal.hide();
      if (type == 'opencart') {
        this.show_cart_modal();
      }
      if (type == 'all_complete') {
        this.$refs.can_go_calendar_modal.hide();
      }
    },
    SaveOrder() {
      if (this.Order.Meals.length == 0) {
        this.$parent.Msg('購物車沒有餐點！', '5', 'warning');
        return;
      }
      this.Order.token = localStorage.token;
      const url = window.location.href

      const u = new URL(url);
      // 取得路徑
      let pathname = u.pathname; // "/dev_sampo_client_web/SpaReservedMain"
      // 去掉最後一段
      let basePath = pathname.substring(0, pathname.lastIndexOf("/") + 1);

      // 拼回完整網址
      let resultpath = `${u.origin}${basePath}`;
      this.Order.url = resultpath + 'OrderOrReservation?token=' + localStorage.token;
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(JSON.stringify(this.Order))
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.SaveOrder,
        data: post_data
      })
        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          if (data.check) {
            //this.GetOrderByID(data.data);
            this.hide_check_date_modal();
            this.hide_order_finished_modal();
          } else {
            this.$parent.Msg(data.msg, '5', 'warning');
          }
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    },
    GetOrderByID(Orderno) {
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(
          JSON.stringify({
            Orderno: Orderno
          })
        )
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.GetOrderByID,
        data: post_data
      })
        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          if (data.check) {
            this.Order_finish = JSON.parse(data.data);
            this.show_order_finished_modal();
          } else {
            this.$parent.Msg(data.msg, '5', 'warning');
          }
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    },
    show_order_finished_modal() {
      this.$refs.order_finished_modal.show();
    },
    hide_order_finished_modal() {
      this.Order_finish = [];
      this.Order.Meals = [];
      this.Order.AMOUNT = 0;
      this.Meal_Supldt_List = [];
      this.MealList = [];
      this.DateList = [];
      this.selectedDate = '';
      this.selectedDateShow = '';
      this.SupldtStart = '';
      this.SupldtEnd = '';
      this.SupldtShow = '';
      this.init();
      this.Menu = '';
      this.MenuList = [];
      this.$refs.order_finished_modal.hide();
      this.show_can_go_calendar_modal();
    },
    show_can_go_calendar_modal() {
      this.$refs.can_go_calendar_modal.show();
    },
    hide_can_go_calendar_modal() {
      this.$refs.can_go_calendar_modal.hide();
    },
    hide_can_call_supl_modal() {
      this.$refs.can_call_supl_modal.hide();
    },
    show_can_call_supl_modal() {
      this.$refs.can_call_supl_modal.show();
    },
    selectAll(event) {
      // 當 focus 時，選取所有文字
      event.target.select();
    },
    check_in_cart() {
      for (var i in this.DateList) {
        this.DateList[i].Is_selected = false;
      }
      for (var i in this.Order.Meals) {
        let DateList_s = this.DateList.find(x => x.date == this.Order.Meals[i].Supldt)
        DateList_s.Is_selected = true;
        if (this.Order.Meals[i].Name == '送餐服務') { }
        else if (this.Order.Meals[i].Supldt == this.selectedDate.replaceAll('-', '/')) {
          let tMealModel = this.MealList.find(x => x.Model == this.Order.Meals[i].Model)
          let tMealSupl = tMealModel.SuplList.find(x => x.SuplNO == this.Order.Meals[i].SuplNO)
          //console.log(tMealSupl)
          let tMeal = tMealSupl.MealList.find(x => x.Flowno == this.Order.Meals[i].MealFlowno)
          //this.$set(tMeal, 'Is_selected', true)
          tMeal["Is_selected"] = true;
          //console.log(tMeal)
        }
      }
      //console.log(this.MealList)
    },
    deliveryClick(obj) {
      obj.delivery = !obj.delivery;
      if (obj.delivery) {
        let tempObj = JSON.parse(JSON.stringify(this.Default_Meal));
        tempObj.Flowno = '';
        tempObj.Homeid = this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Homeid')
        );
        tempObj.Supldt = this.selectedDate.replaceAll('-', '/');
        tempObj.UserName = this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('UserName')
        );
        tempObj.Mobile = this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Mobile')
        );
        tempObj.Suplnm = '';
        tempObj.SuplNO = '';
        tempObj.ShopNO = this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('ShopNO')
        );
        tempObj.Type = '訂餐';
        tempObj.Model = obj.Model;
        tempObj.Name = '送餐服務';
        tempObj.Qty = 1;
        tempObj.Pricing = 80;
        tempObj.Selling = 80;
        tempObj.TotalSelling = 80;
        tempObj.Remark = '';
        tempObj.Createmem = this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        );
        tempObj.Updmem = this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        );
        tempObj.MealFlowno = ''
        //console.log(this.select_Meal)
        this.Order.Meals.push(JSON.parse(JSON.stringify(tempObj)));

      }
      else {
        let idx = this.Order.Meals.findIndex(x => x.Supldt == this.selectedDate.replaceAll('-', '/') && x.Model == obj.Model && x.Name == '送餐服務')
        if (idx > -1) {
          this.Order.Meals.splice(idx, 1);
        }
      }
      this.calc_AMOUNT();
    },
    sortOrder(dataArray) {
      return dataArray.sort((a, b) => {
        // 1. 先比 Supldt（日期）
        if (a.Supldt < b.Supldt) return -1;
        if (a.Supldt > b.Supldt) return 1;

        // 2. Supldt 相同，比 Model（早餐/午餐）
        if (a.Model > b.Model) return -1;
        if (a.Model < b.Model) return 1;

        // 3. Model 相同，比 Name（送餐服務要放前面）
        const isASongCan = a.Name === '送餐服務' ? 0 : 1;
        const isBSongCan = b.Name === '送餐服務' ? 0 : 1;
        if (isASongCan !== isBSongCan) return isASongCan - isBSongCan;

        // 4. 都一樣，不動
        return 0;
      });
    }
  }
};
</script>
<style scoped>
.cust_card_icon2 {
  width: 40px;
  height: 40px;
}

.cust_card {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: #FFF3E2;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 80px;
  /* width: 100%; */
  cursor: pointer;
}

.cust_card_disable {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 80px;
  /* width: 100%; */
  cursor: pointer;
}

.cust_card_vLOGO {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid white;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  height: 200px;
  width: 100%;
  max-width: 400px;
}

.cust_card_meal {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 80px;
  /* width: 100%; */
  cursor: pointer;
}

.cust_card_meal2 {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cust_card_meal_selected {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: #FFF3E2;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 80px;
  /* width: 100%; */
  cursor: pointer;
}

.cust_card_meal_delivery {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  /* min-height: 80px; */
  /* width: 100%; */
  cursor: pointer;
}

.cust_card_meal_delivery_selected {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: #FFF3E2;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  /* min-height: 80px; */
  /* width: 100%; */
  cursor: pointer;
}

.cust_card_time {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 110px;
  width: 100%;
  cursor: pointer;
}

.date_modal_button {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  border-radius: 0.5rem;
  height: 60px;
  width: 60px;
  cursor: pointer;
  line-height: 10px;
}

.date_change_week_button {
  width: 2rem;
  height: 3rem;
  background-color: rgb(236, 108, 1);
  border: 0px;
  align-items: center;
  display: flex;
  justify-content: center;
}

@media (min-width: 1024px) {
  .cust_card_time_label {
    font-size: 2rem;
    color: #E27814;
    cursor: pointer;
  }

  .cust_card_time_div {
    -ms-flex-pack: justify !important;
    -webkit-box-pack: justify !important;
    justify-content: flex-start !important;
  }

  .cust_card_icon {
    width: 55px;
    height: 48px;
  }
}

@media (max-width: 1023px) {
  .cust_card_time_label {
    font-size: 1.75rem;
    color: #E27814;
    cursor: pointer;
  }

  .cust_card_time_div {
    -ms-flex-align: center !important;
    -webkit-box-align: center !important;
    align-items: center !important;
    -ms-flex-pack: center !important;
    -webkit-box-pack: center !important;
    justify-content: center !important;
    display: -ms-flexbox !important;
    display: -webkit-box !important;
    display: flex !important;
  }

  .cust_card_icon {
    width: 40px;
    height: 40px;
  }
}

.cust_card_time_modal {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: white;
  border-radius: 0.5rem;
  /* box-shadow: 1px 1px 1px 1px #CBB79A; */
  min-height: 50px;
  width: 100%;
  cursor: pointer;
}

.cust_card_icon_modal {
  width: 2rem;
  height: 2rem;
}

.cust_card_time_label_modal {
  font-size: 1.5rem;
  color: #E27814;
  /* cursor: pointer; */
}

.customer_order_label {
  font-size: 2rem;
  line-height: 65px;
  background-color: white;
  border-radius: 5px;
  /* text-align: start; */
}

.customer_order_model_card {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 100px;
  width: 100%;
  cursor: pointer;
}

.customer_order_model_card_disable {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #E27814;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 100px;
  width: 100%;
  cursor: pointer;
  filter: grayscale(100%);
}

.card-flex {
  flex: 1 1 100%;
  max-width: 100%;
  position: relative;
}

@media (min-width: 768px) {
  .card-flex {
    flex: 1 1 calc(50% - 0.5rem);
    max-width: calc(50% - 0.5rem);
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/View/Meal/MealMenu.vue